import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ViewChild,
  Input,
} from '@angular/core';
import { sharedText } from '../shared/utilities';
import { AuthService } from 'libs/shared-auth/src/services/auth.service';
import BaseTokenService from '../shared/baseToken.service';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from 'libs/shared-lib1/src/lib/shared/services/config-service.service';

@Component({
  selector: 'lib1-shared-comp',
  templateUrl: './shared-comp.component.html',
  styleUrls: ['./shared-comp.component.scss'],
})
export class SharedCompComponent implements OnInit, OnDestroy {

  @ViewChild('modalDialog', { static: true }) modalDialog: any;

  someSharedProp: string | undefined;
  isLoggedIn: boolean;
  loginUrl: string;
  shouldEnforceLogin: boolean;

  constructor(
    private authService: AuthService,
    private baseTokenService: BaseTokenService,
    private cookieService: CookieService,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {

    this.addEventListenerForWindowPostMessages();

    this.checkIfWeHaveAValidTokenSoWeAreLoggedInAfterRefresh();

    //should be based on environment
    //https://itai-nx-login.web.app
    if (this.configService && this.configService.production == false) {

      this.loginUrl = 'http://localhost:4204/';

    } else {

      this.loginUrl = 'https://itai-nx-login.web.app';

    }

    this.someSharedProp = sharedText;

  }

  checkIfWeHaveAValidTokenSoWeAreLoggedInAfterRefresh() {

    //let isProduction = environment.production;

    if (this.configService.shouldEnforceLogin) {

      this.shouldEnforceLogin = true;
      let isValidToken = this.baseTokenService.isValidToken();

      this.authService.setIsLoggedIn(isValidToken);
      this.isLoggedIn = isValidToken;

    } else {

      this.shouldEnforceLogin = false;
      this.authService.setIsLoggedIn(true);
      this.isLoggedIn = true;

    }

  }

  addEventListenerForWindowPostMessages() {

    window.addEventListener(
      'message',
      (dataSent) => {

        // if (dataSent.origin !== "http://localhost:4204"")
        //   return;

        //var authToken = dataSent.data.authToken;

        //let isProduction = environment.production;


        let isLoginEventMessage: boolean;

        if (dataSent && dataSent.data && dataSent.data.authToken) {

          isLoginEventMessage = true;

        }

        if (isLoginEventMessage) {

          this.handleLoginEventMsg(dataSent);

        }


      },
      false
    );
  }

  handleLoginEventMsg(dataSent: MessageEvent<any>) {

    if (this.configService.shouldEnforceLogin) {

      let authTokenReceived: any = dataSent.data.authToken;

      
      //this.baseTokenService.authTokenProp = authTokenReceived;

      var cookieObjProps = { path: "/" }
      this.cookieService.set('authTokenFromBackend', authTokenReceived, cookieObjProps);

      this.isLoggedIn = this.baseTokenService.isValidToken(authTokenReceived);

      if (this.isLoggedIn) {

        document.getElementById('closeModalButton').click();

        this.authService.setIsLoggedIn(true);

      } else {

        this.authService.setIsLoggedIn(false);

      }

    } else {

      //stay valid on local
      this.authService.setIsLoggedIn(true);

    }

  }

  logOut($event: any) {

    this.authService.logOut();

    this.isLoggedIn = false;

    this.authService.setIsLoggedIn(false);

    //this.baseTokenService.authTokenProp = "";

  }

  logIn($event: any) { }

  ngOnDestroy() {

    console.log(`Destroying shared - comp`);

  }

}
